import { render } from "./IconInformation.vue?vue&type=template&id=58cf9273"
import script from "./IconInformation.vue?vue&type=script&lang=js"
export * from "./IconInformation.vue?vue&type=script&lang=js"
script.render = render

export default script